<template>
  <cga-manager-list></cga-manager-list>
</template>

<script>
import CgaManagerList from "./../../../components/cga/manager/list";
export default {
  data: () => ({}),
  metaInfo() {
    return {
      title: this.$t("cga.manager.title"),
    };
  },
  components: {
    CgaManagerList,
  },
};
</script>
